import React, { useEffect, useState } from 'react';
import LangStorageManager from '../lang/LangStorageManager';
import LanguageManager from '../lang/LanguageManager';
import './footer.css';

export default function Footer() {
    const storage = new LangStorageManager(null);
    const[language, setLanguage] = useState(storage.getStorage());
    const[texts, setTexts] = useState(null);

    useEffect(() => {
        const loadText = async () => {
            const translator = new LanguageManager(storage.getStorage());
            await translator.loadTranslation();
            setTexts(translator.getAll());
        };
        loadText();
    }, [language]);

    return (
        <footer>
            <div className="footer-nav">
                <nav>
                    <a href="#about-me">{texts?.footer?.aboutMe || 'About me'}</a>
                    <a href="#skills">{texts?.footer?.skills || 'Skills'}</a>
                    <a href="#projects">{texts?.footer?.projects || 'Projects'}</a>
                    <a href="#contact">{texts?.footer?.contact || 'Contact me'}</a>
                </nav>
            </div>
            <p>{texts?.footer?.copyright || 'Copyright © Nahuel Tellechea Freire All Rights Reserved. ❤️'}</p>
            <div className="social-media">
                <a href="https://uy.linkedin.com/in/nahuel-tellechea-freire-818a77210" target='_blank'>LinkedIn</a>
                <a href="https://github.com/Soy-Nahuel" target='_blank'>GitHub</a>
                <a href="https://g.dev/nahuel-tellechea-freire" target='_blank'>Google Developers</a>
            </div>
        </footer>
    );
}